// Al inicio igual que antes...
import React, { useRef, useState } from 'react';
import {
  Slider, Checkbox, Button, Typography, IconButton, TextField,
  ToggleButton, ToggleButtonGroup
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

// Luego importar:
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

export default function TonoYSaturacionEditor() {
  const [hue, setHue] = useState(0);
  const [saturation, setSaturation] = useState(100);
  const [lightness, setLightness] = useState(100);
  const [colorize, setColorize] = useState(false);
  const [selection, setSelection] = useState(null);
  const [mode, setMode] = useState('barras');
  const [originalPixels, setOriginalPixels] = useState(null);

  const canvasRef = useRef(null);
  const imageRef = useRef(null);

  const [isManualSelection, setIsManualSelection] = useState(false);
  const [manualRect, setManualRect] = useState({ x: 50, y: 50, width: 100, height: 100 });
  const [draggingCorner, setDraggingCorner] = useState(null); // 'nw', 'ne', 'sw', 'se' o null
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

const configuraciones = [
    { nombre: "rojo", tono: -39, saturacion: 103, luminosidad: 93 },
    { nombre: "amarillovivido", tono: 9, saturacion: 137, luminosidad: 109 },
    { nombre: "verdeneon", tono: 31, saturacion: 100, luminosidad: 100 },
    { nombre: "verdenormal", tono: 64, saturacion: 83, luminosidad: 97 },
    { nombre: "verdemilitar", tono: 64, saturacion: 46, luminosidad: 52 },
    { nombre: "rosapastel", tono: -105, saturacion: 44, luminosidad: 174 },
    { nombre: "moradoclaro", tono: -132, saturacion: 50, luminosidad: 174 },
    { nombre: "moradooscuro", tono: -131, saturacion: 64, luminosidad: 101 },
    { nombre: "naranja", tono: -19, saturacion: 200, luminosidad: 114 },
    { nombre: "azulcielo", tono: 142, saturacion: 101, luminosidad: 101 },
    { nombre: "azulrey", tono: 169, saturacion: 101, luminosidad: 101 },
    { nombre: "turquesa", tono: 124, saturacion: 86, luminosidad: 117 },
    { nombre: "fucsia", tono: -108, saturacion: 102, luminosidad: 107 },
    { nombre: "grisoscuro", tono: 0, saturacion: 0, luminosidad: 85 },
    { nombre: "grisclaro", tono: 0, saturacion: 0, luminosidad: 145 },
    { nombre: "blanco", tono: 0, saturacion: 0, luminosidad: 200 },
    { nombre: "negro", tono: 0, saturacion: 0, luminosidad: 17 },
    { nombre: "cafeoscuro", tono: -24, saturacion: 57, luminosidad: 47 },
    { nombre: "cafeclaro", tono: -24, saturacion: 57, luminosidad: 98 }
  ];



  const handleImageLoad = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const maxW = window.innerWidth * 0.9;
    const maxH = window.innerHeight * 0.7;

    let width = imageRef.current.naturalWidth;
    let height = imageRef.current.naturalHeight;
    const ratio = Math.min(maxW / width, maxH / height, 1);
    width *= ratio;
    height *= ratio;

    canvas.width = width;
    canvas.height = height;

    ctx.drawImage(imageRef.current, 0, 0, width, height);
    const originalData = ctx.getImageData(0, 0, width, height);
    setOriginalPixels(originalData);
    applyAdjustments(originalData, true); // true = mostrar selección
  };

  const applyAdjustments = (baseImageData = null, drawSelection = true) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const sourceData = baseImageData || originalPixels;
    if (!sourceData) return;

    const imgData = new ImageData(new Uint8ClampedArray(sourceData.data), sourceData.width, sourceData.height);
    const data = imgData.data;

    for (let y = 0; y < canvas.height; y++) {
      for (let x = 0; x < canvas.width; x++) {
        const index = (y * canvas.width + x) * 4;



        const sel = isManualSelection ? manualRect : selection;
if (sel) {
  const { x: sx, y: sy, width: sw, height: sh } = sel;
  if (x < sx || x > sx + sw || y < sy || y > sy + sh) continue;
}

if (sel && drawSelection) {
  ctx.strokeStyle = "red";
  ctx.lineWidth = 2;
  ctx.strokeRect(sel.x, sel.y, sel.width, sel.height);
}



        let r = data[index];
        let g = data[index + 1];
        let b = data[index + 2];

        let [h, s, l] = rgbToHsl(r, g, b);

        if (colorize) {
          h = hue / 360;
          s = saturation / 100;
          l = lightness / 100;
        } else {
          h = (h + hue / 360) % 1;
          if (h < 0) h += 1;
          s = Math.min(1, Math.max(0, s * (saturation / 100)));
          l = Math.min(1, Math.max(0, l * (lightness / 100)));
        }

        const [newR, newG, newB] = hslToRgb(h, s, l);
        data[index] = newR;
        data[index + 1] = newG;
        data[index + 2] = newB;
      }
    }

    ctx.putImageData(imgData, 0, 0);

    // ❌ No dibujar el rectángulo si se indicó que no
    if ((selection || isManualSelection) && drawSelection) {
      const sel = isManualSelection ? manualRect : selection;
      ctx.strokeStyle = "red";
      ctx.lineWidth = 2;
      ctx.strokeRect(sel.x, sel.y, sel.width, sel.height);
    }
  };

  const downloadImage = () => {
    // 👉 aplicar sin dibujar el rectángulo
    applyAdjustments(null, false);
    const canvas = canvasRef.current;
    const link = document.createElement("a");
    link.download = "imagen_editada.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
    // 👈 volver a mostrar el rectángulo después
    applyAdjustments(null, true);
  };

  let isDrawing = false;
  let startX = 0;
  let startY = 0;

  const handleMouseDown = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    startX = e.clientX - rect.left;
    startY = e.clientY - rect.top;
    isDrawing = true;
  };

  const handleMouseUp = (e) => {
    if (!isDrawing) return;
    const rect = canvasRef.current.getBoundingClientRect();
    const endX = e.clientX - rect.left;
    const endY = e.clientY - rect.top;

    const x = Math.min(startX, endX);
    const y = Math.min(startY, endY);
    const width = Math.abs(endX - startX);
    const height = Math.abs(endY - startY);

    setSelection({ x, y, width, height });
    isDrawing = false;

    setTimeout(() => applyAdjustments(), 50);
  };

  const adjustValue = (setter, value, delta, min, max) => {
    const newVal = Math.min(max, Math.max(min, value + delta));
    setter(newVal);
    applyAdjustments();
  };

const generarPaqueteAmarillo = async () => {
    if (!originalPixels) return;
  
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const zip = new JSZip();
  
    for (const config of configuraciones) {
        const tempData = new ImageData(new Uint8ClampedArray(originalPixels.data), originalPixels.width, originalPixels.height);
        const data = tempData.data;
      
        for (let y = 0; y < canvas.height; y++) {
          for (let x = 0; x < canvas.width; x++) {
            const index = (y * canvas.width + x) * 4;
            if (selection) {
              const { x: sx, y: sy, width: sw, height: sh } = selection;
              if (x < sx || x > sx + sw || y < sy || y > sy + sh) continue;
            }
      
            let r = data[index];
            let g = data[index + 1];
            let b = data[index + 2];
      
            let [h, s, l] = rgbToHsl(r, g, b);
      
            // APLICAR CAMBIOS RELATIVOS COMO EN `applyAdjustments`
            h = (h + config.tono / 360) % 1;
            if (h < 0) h += 1;
      
            s = Math.min(1, Math.max(0, s * (config.saturacion / 100)));
            l = Math.min(1, Math.max(0, l * (config.luminosidad / 100)));
      
            const [newR, newG, newB] = hslToRgb(h, s, l);
            data[index] = newR;
            data[index + 1] = newG;
            data[index + 2] = newB;
          }
        }
      
        ctx.putImageData(tempData, 0, 0);
        const dataUrl = canvas.toDataURL("image/png");
        const imgBlob = await (await fetch(dataUrl)).blob();
        zip.file(`${config.nombre}.png`, imgBlob);
      }
      
  
    const zipBlob = await zip.generateAsync({ type: "blob" });
    saveAs(zipBlob, "PaqueteAmarillo.zip");
  };



  const handleTouchStart = (e) => {
    if (!isManualSelection) return;
    const touch = e.touches[0];
    const rectCanvas = canvasRef.current.getBoundingClientRect();
    const tx = touch.clientX - rectCanvas.left;
    const ty = touch.clientY - rectCanvas.top;
    const corners = {
      nw: { x: manualRect.x, y: manualRect.y },
      ne: { x: manualRect.x + manualRect.width, y: manualRect.y },
      sw: { x: manualRect.x, y: manualRect.y + manualRect.height },
      se: { x: manualRect.x + manualRect.width, y: manualRect.y + manualRect.height },
    };
    for (const pos in corners) {
      const c = corners[pos];
      if (Math.hypot(tx - c.x, ty - c.y) < 20) {
        setDraggingCorner(pos);
        return;
      }
    }
    // Drag entire rectangle if touched inside
    if (
      tx > manualRect.x && tx < manualRect.x + manualRect.width &&
      ty > manualRect.y && ty < manualRect.y + manualRect.height
    ) {
      setDraggingCorner('move');
      setDragOffset({ x: tx - manualRect.x, y: ty - manualRect.y });
    }
  };
  const handleTouchMove = (e) => {
    if (!draggingCorner) return;
    e.preventDefault();
    const touch = e.touches[0];
    const rectCanvas = canvasRef.current.getBoundingClientRect();
    let tx = touch.clientX - rectCanvas.left;
    let ty = touch.clientY - rectCanvas.top;
    const r = { ...manualRect };
    if (draggingCorner === 'move') {
      r.x = tx - dragOffset.x;
      r.y = ty - dragOffset.y;
    } else {
      if (draggingCorner.includes('e')) r.width = tx - r.x;
      if (draggingCorner.includes('s')) r.height = ty - r.y;
      if (draggingCorner.includes('w')) {
        r.width += r.x - tx;
        r.x = tx;
      }
      if (draggingCorner.includes('n')) {
        r.height += r.y - ty;
        r.y = ty;
      }
    }
    if (r.width < 10) r.width = 10;
    if (r.height < 10) r.height = 10;
    setManualRect(r);
    applyAdjustments();
  };
  const handleTouchEnd = () => {
    setDraggingCorner(null);
  };
  

  return (
    <div style={{ padding: 20, background: "white" }}>
      <Typography variant="h5">Tono y Saturación</Typography>

      <input
        type="file"
        accept="image/*"
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            const reader = new FileReader();
            reader.onload = () => {
              imageRef.current.src = reader.result;
            };
            reader.readAsDataURL(file);
          }
        }}
      />



<div style={{ marginTop: 20 }}>
  <Button
    variant="outlined"
    color="primary"
    onClick={() => {
      setIsManualSelection(true);
      setSelection(null);
      applyAdjustments();
    }}
  >
    Seleccionar
  </Button>

  <Button
    variant="outlined"
    color="secondary"
    style={{ marginLeft: 10 }}
    onClick={() => {
      setIsManualSelection(false);
      setManualRect({ x: 50, y: 50, width: 100, height: 100 });
      setSelection(null);
      applyAdjustments();
    }}
  >
    Cancelar Selección
  </Button>
</div>


      <canvas
        ref={canvasRef}
        style={{ display: 'block', marginTop: 20, maxWidth: '100%', border: "1px solid #ccc", cursor: "crosshair" }}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
      />

      <img
        ref={imageRef}
        style={{ display: "none" }}
        onLoad={handleImageLoad}
        alt=""
      />


{isManualSelection && (
  <div style={{ marginTop: 20 }}>
    <Typography>Modificar selección manual:</Typography>
    {["x", "y", "width", "height"].map((key) => (
      <div key={key} style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
        <Typography style={{ width: 80 }}>{key}:</Typography>
        <TextField
          type="number"
          size="small"
          value={manualRect[key]}
          onChange={(e) => {
            const val = parseInt(e.target.value, 10);
            const updated = { ...manualRect, [key]: isNaN(val) ? 0 : val };
            setManualRect(updated);
            applyAdjustments();
          }}
          style={{ width: 80 }}
        />
      </div>
    ))}
  </div>
)}

onTouchStart={handleTouchStart}
onTouchMove={handleTouchMove}
onTouchEnd={handleTouchEnd}




      <ToggleButtonGroup value={mode} exclusive onChange={(e, val) => val && setMode(val)} style={{ marginTop: 20 }}>
        <ToggleButton value="barras">Barras</ToggleButton>
        <ToggleButton value="conteo">Conteo</ToggleButton>
      </ToggleButtonGroup>

      {mode === 'barras' ? (
        <div style={{ marginTop: 20 }}>
          <Typography gutterBottom>Tono</Typography>
          <Slider value={hue} onChange={(e, val) => { setHue(val); applyAdjustments(); }} min={-180} max={180} />
          <Typography gutterBottom>Saturación</Typography>
          <Slider value={saturation} onChange={(e, val) => { setSaturation(val); applyAdjustments(); }} min={0} max={200} />
          <Typography gutterBottom>Luminosidad</Typography>
          <Slider value={lightness} onChange={(e, val) => { setLightness(val); applyAdjustments(); }} min={0} max={200} />
        </div>
      ) : (
        <div style={{ marginTop: 20 }}>
          {[{
            label: 'Tono', value: hue, setter: setHue, min: -180, max: 180
          }, {
            label: 'Saturación', value: saturation, setter: setSaturation, min: 0, max: 200
          }, {
            label: 'Luminosidad', value: lightness, setter: setLightness, min: 0, max: 200
          }].map(({ label, value, setter, min, max }) => (
            <div key={label} style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
              <Typography style={{ width: 120 }}>{label}</Typography>
              <IconButton onClick={() => adjustValue(setter, value, -1, min, max)}><RemoveIcon /></IconButton>
              <TextField size="small" value={value} onChange={(e) => { setter(Number(e.target.value)); applyAdjustments(); }} style={{ width: 70, margin: '0 10px' }} />
              <IconButton onClick={() => adjustValue(setter, value, 1, min, max)}><AddIcon /></IconButton>
            </div>
          ))}
        </div>
      )}

      <div>
        <Checkbox
          checked={colorize}
          onChange={(e) => {
            setColorize(e.target.checked);
            applyAdjustments();
          }}
        />
        <label>Colorear</label>
      </div>

      <Button variant="contained" onClick={downloadImage}>Descargar Img Previa</Button>


      <div
  onClick={generarPaqueteAmarillo}
  style={{
    marginTop: 10,
    width: 150,
    height: 150,
    borderRadius: '50%',
    background: '#f9c404',
    color: 'black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    cursor: 'pointer'
  }}
>
  Paquete Amarillo
</div>



    </div>




  );
}

// Conversión RGB <-> HSL
function rgbToHsl(r, g, b) {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s, l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)); break;
      case g: h = ((b - r) / d + 2); break;
      case b: h = ((r - g) / d + 4); break;
    }
    h /= 6;
  }

  return [h, s, l];
}

function hslToRgb(h, s, l) {
  let r, g, b;
  if (s === 0) r = g = b = l;
  else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}
